module.exports = __webpack_public_path__ + "static/img/logo.bfdc5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/assets/images/common/logo.png
// module id = hCNt
// module chunks = 42